import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'framer-motion';
import { IGlobalStoreState } from '../store';
import { hideMenu } from '../store/menu/actions';
import { OnlineCardPaymentLink, PaymentDocumentsLink, RLink, UserAgreementLink } from '../components/UI';
import { Routes } from '../store/routes';
import { EventHelper } from '../helpers';
import { DomainType } from '../store/enums';

type MenuType = {
  isShow: boolean;
  hideMenu?: () => void;
};

const Menu = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isShow = useSelector<IGlobalStoreState, boolean>((state) => state.menu.isShow);
  const { getDomainType } = EventHelper;
  const isDomainKz = getDomainType(window.location.host) === DomainType.Kz;

  const handleLinkClick = () => {
    dispatch(hideMenu());
  };
  const containerVariants = {
    hidden: {
      x: '-100%',
      transition: { duration: 0.3 },
    },
    visible: {
      x: '0%',
    },
    close: {
      x: '-100%',
      transition: { duration: 0.3 },
    },
  };

  const contactsTitle = isDomainKz ? 'Контакты' : t('Menu.Contacts');
  const aboutUsTitle = isDomainKz ? 'О нас' : t<string>('Menu.AboutUs');
  const paymentTitle = isDomainKz ? 'Оплата' : t<string>('Menu.Payment');
  const paymentMethodsTitle = isDomainKz ? 'Методы оплаты' : t<string>('Menu.PaymentMethods');

  return (
    <AnimatePresence>
      {isShow && (
        <Container
          variants={containerVariants}
          initial={'hidden'}
          animate={'visible'}
          exit={'close'}
          key="menu"
          isShow={isShow}
        >
          <Navigation>
            <MenuBlock>
              <Title>{aboutUsTitle}</Title>
              <List>
                <ListItem>
                  <RLink to={Routes.Contacts} title={contactsTitle} onClick={handleLinkClick}>
                    {contactsTitle}
                  </RLink>
                </ListItem>
              </List>
            </MenuBlock>
            <MenuBlock grow>
              <Title>{paymentTitle}</Title>
              <List>
                <ListItem>
                  <RLink to={Routes.PaymentsInfo} title={paymentMethodsTitle} onClick={handleLinkClick}>
                    {paymentMethodsTitle}
                  </RLink>
                </ListItem>
                {/* <ListItem>
                  <OnlineCardPaymentLink onClick={handleLinkClick} />
                </ListItem>
                <ListItem>
                  <PaymentDocumentsLink onClick={handleLinkClick} />
                </ListItem> */}
              </List>
            </MenuBlock>
            <MenuBlock footer>
              <List>
                <ListItem>
                  <UserAgreementLink onClick={handleLinkClick} />
                </ListItem>
              </List>
            </MenuBlock>
          </Navigation>
        </Container>
      )}
    </AnimatePresence>
  );
};

const Container = styled(motion.aside)<MenuType>`
  position: fixed;
  width: 100%;
  height: 100%;
  max-height: 100vh;
  z-index: 800;
  padding: 0;
  margin: 0;
  top: 0;
  bottom: 0;
  max-width: ${(props) => props.theme.maxWidth};
  display: ${(props) => !props.isShow && 'none'};
  background-color: rgba(0, 0, 0, 0.2);
`;

const Navigation = styled.nav`
  background-color: ${(props) => props.theme.colors.bg};
  max-width: calc(100% - 25px);
  padding: 130px 25px 25px;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const AMenuBlock = styled(motion.section as any)``;
const MenuBlock = styled(AMenuBlock as any)`
  color: ${(props) => props.theme.colors.text};
  font-size: 14px;
  margin-bottom: ${(props: any) => !props.footer && '25px'};
  flex: ${(props: any) => props.grow && 1};
`;

const Title = styled.h2`
  font-size: 14px;
  font-family: ${(props) => props.theme.fonts.lighterFont};
  line-height: 18px;
  margin: 0 0 15px 0;
  padding: 0;
  text-transform: uppercase;
  color: ${(props) => props.theme.colors.accent};
`;

const List = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
`;

const ListItem = styled.li`
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export default Menu;
